<script>
  import { status } from "./status.js";
  import page from "page";
  import { onMount } from 'svelte';

  import { fancyAlert } from "./notification.js"
  import { getSubscription, requestPasswordReset } from "./apihandler.js";
  import { tl } from "./multilang.js";

  let id, email, password, emailReset;
  let resetPasswordModalFlag = false;

  let elm;

     onMount(function() {

        $status.notification.show = false;
        $status.notification.confirm = false;

        elm.focus();
    });

  function login() {
    
    getSubscription(email, password)
    .then((subscription) => {
        $status.subscription = subscription;
        $status.loggedIn = true;
        
        page("/services");
    })
    .catch(async (error) => {
      if (error == 403) {
        await fancyAlert(tl("Invalid credentials"), tl("Error"));
      }
      else if (error = 490) {
        await fancyAlert(tl("You need to enroll your administrative ZofToken before accessing ZaaS"), tl("Error"));
      }
      else {
        await fancyAlert(error, tl("Error"));
      }
    });
  }

  function resetPasswordModal() {
    emailReset = "";
    resetPasswordModalFlag = true;
  }

  function resetPassword() {

    requestPasswordReset(emailReset)
    .then(async () => {
      await fancyAlert(tl("Password reset email sent"));
      resetPasswordModalFlag = false;
      page("/login");
    })
    .catch(async (error) => {
      if (error == 404) {
        await fancyAlert(tl("No subscription exists with that email"), tl("Error"));
      } else {
        await fancyAlert(error);
      }
    });
  }

function returnLogin(event) {
    if (event.key === 'Enter') {
        login();
    }
}
</script>

<svelte:head>
  <title>ZaaS - {tl("Log in")}</title>
</svelte:head>


<section class=" has-background-grey-lightest	">
  <div class="container">

<div class="columns is-centered content">
  <div class="column is-one-third">
    <div class="box ">
      <h4>{tl("Log in")}</h4>
      <p>
        {tl("Do not have an account?")}
        <a on:click={() => page('/registration')}>{tl("Sign up for free")}</a>
      </p>

      <div class="zt-field-wrapper">
        <label>{tl("Email")}</label>
        <div class="control">
          <input
            class="input"
            type="text"
            bind:value={email}
            placeholder={tl("Email")} bind:this={elm} />
        </div>
      </div>

      <div class="zt-field-wrapper">
        <label>{tl("Password")}</label>
        <div class="control">
          <input
          class="input"
          type="password"
          bind:value={password}
          placeholder={tl("Password")} on:keydown={returnLogin}/>
        </div>
      </div>


      <div class="field">
        <p class="has-text-right is-size-7 help">
          <a on:click={resetPasswordModal}>{tl("I forgot my password")}</a>
        </p>
      </div>

      <nav class="level-left">
          <div class="level-item has-text-centered">
            <button class="button is-link" on:click={login} >
              {tl("Log in")}
            </button>
          </div>
          <div class="level-item has-text-centered">
            <button
              class="button"
              on:click={() => page('/')}>
              {tl("Cancel")}
            </button>
          </div>
        </nav>
    </div>

  </div>

</div>

{#if resetPasswordModalFlag}
  <div class="modal is-active">
    <div class="modal-background" />

    <div class="modal-content">
      <div class="card">
        <div class="card-heading">
          <div class="level">
              <div class="level-left">
                  <div class="level-item has-text-weight-semibold">
                    {tl("Reset password")}
                  </div>
              </div>
              
              <div class="level-right">
                  <div class="level-item">
                      <button
                  class="delete is-large"
                  on:click={() => {
                    resetPasswordModalFlag = false;
                  }}>
                  </div>
              </div>
          </div>
        </div>

        <div class="card-content is-clearfix">
          <div class="zt-field-wrapper">
              <label>{tl("Email")}</label>
              <div class="control">
                <input class="input" type="text" bind:value={emailReset} />
              </div>
              <p class="help">{tl("Please enter your email address")}</p>
          </div>

          <button
            class="button is-primary"
            on:click={resetPassword}>
            {tl("Submit")}
          </button>
        </div>
      </div>
    </div>
  </div>
{/if}

  </div>

</section>